import { render, staticRenderFns } from "./LoginBA.vue?vue&type=template&id=03f69124&"
import script from "./LoginBA.vue?vue&type=script&lang=js&"
export * from "./LoginBA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports